import { useCallback, useEffect, useState } from 'react';
import SurveyInstanceService, { GetSurveyInstanceResponse } from '../../Services/SurveyInstanceService';
import { ErrorHandler } from '../../Services/UserApi';
import { FullSurveyInstance, SurveyForm, SurveyResponseForCreate } from 'shared-components';
import Loading from './Loading';
import ErrorState from './ErrorState';
import toast from 'react-hot-toast';

interface ViewSurveyProps {
	uuid: string;
	token: string;
}

export default function ViewSurvey(props: ViewSurveyProps) {
	return (
		<div className="view-survey-page">
			<Content {...props} />
		</div>
	);
}

function Content(props: ViewSurveyProps) {
	const { uuid, token } = props;

	const [response, setResponse] = useState<GetSurveyInstanceResponse | null>(null);
	useEffect(() => {
		SurveyInstanceService.getSurveyInstance(uuid, token)
			.then((res) => setResponse(res))
			.catch((e: unknown) => ErrorHandler.toast(e));
	}, [uuid, token]);

	const onSubmit = useCallback(async (surveyInstance: FullSurveyInstance, responses: SurveyResponseForCreate[]) => {
		try {
			const res = await SurveyInstanceService.submitSurveyResponses(
				surveyInstance.Uuid,
				surveyInstance.Token,
				responses,
			);
			if (res.success) {
				toast.success(res.message);
			} else {
				toast.error(res.message);
			}
		} catch (e) {
			ErrorHandler.toast(e);
		}
	}, []);

	if (response === null) {
		return <Loading text="Loading survey" />;
	}

	const { surveyInstance, error } = response;
	if (error) {
		return <ErrorState error={error} />;
	}

	return <SurveyForm surveyInstance={surveyInstance} onSubmit={(responses) => onSubmit(surveyInstance, responses)} />;
}
